export default "__VITE_ASSET__C3jR8fZ8__";